import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from "react";
import { ExtensionSlot } from "piral-core";
import Footer from "./Footer";
import Header from "./Header";
import styled from 'styled-components';
import { WallectStatusModel } from "./WallectStatusModel";
import { instance } from "..";
import { Toastify } from "./toastify/toastify";
import { useHistory, useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import { useChainId } from "wagmi";
const emptyWalletStatusParams = {
    transactionModalOpen: false,
    hash: '',
    attemptingTxn: false,
    error: false,
    errorMsg: ''
};
const REGION_CHECK_INTERVAL = 30000;
const AppLayout = ({ children }) => {
    const history = useHistory();
    const location = useLocation();
    const currentChainId = useChainId();
    const [walletStatusParams, setwalletStatusParams] = useState(emptyWalletStatusParams);
    useEffect(() => {
        const handleOpenInfoModel = (params) => {
            if (params) {
                const { status } = params;
                switch (status) {
                    case 0:
                        setwalletStatusParams((current) => ({
                            ...current,
                            transactionModalOpen: true,
                            hash: '',
                            attemptingTxn: true,
                            error: false,
                            errorMsg: '',
                            chainId: params.chainId || currentChainId
                        }));
                        break;
                    case 1:
                        setwalletStatusParams((current) => ({
                            ...current,
                            transactionModalOpen: true,
                            hash: params.hash || '',
                            attemptingTxn: false,
                            error: false,
                            errorMsg: '',
                            chainId: params.chainId || current.chainId || currentChainId
                        }));
                        break;
                    default:
                        setwalletStatusParams((current) => ({
                            ...current,
                            transactionModalOpen: true,
                            hash: '',
                            attemptingTxn: false,
                            error: true,
                            errorMsg: params.errorMsg || params.message || '',
                            chainId: params.chainId || currentChainId
                        }));
                        break;
                }
            }
        };
        const handleChangeInfoModel = (params) => {
            console.log('Shell.ChangeInfoModelEmit==>', params);
            if (params) {
                const { status, hash } = params;
                switch (status) {
                    case 0:
                        setwalletStatusParams((current) => ({
                            ...current,
                            transactionModalOpen: true,
                            hash: '',
                            attemptingTxn: true,
                            error: false,
                            errorMsg: '',
                            chainId: params.chainId || currentChainId
                        }));
                        break;
                    case 1:
                        setwalletStatusParams((current) => ({
                            ...current,
                            transactionModalOpen: true,
                            hash: hash || '',
                            attemptingTxn: false,
                            error: false,
                            errorMsg: '',
                            chainId: params.chainId || current.chainId || currentChainId
                        }));
                        break;
                    default:
                        setwalletStatusParams((current) => ({
                            ...current,
                            transactionModalOpen: true,
                            hash: '',
                            attemptingTxn: false,
                            error: true,
                            errorMsg: params.errorMsg || params.message || '',
                            chainId: params.chainId || currentChainId
                        }));
                        break;
                }
            }
        };
        instance.on('Shell.OpenInfoModelEmit', handleOpenInfoModel);
        instance.on('Shell.ChangeInfoModelEmit', handleChangeInfoModel);
        return () => {
            instance.off('Shell.OpenInfoModelEmit', handleOpenInfoModel);
            instance.off('Shell.ChangeInfoModelEmit', handleChangeInfoModel);
        };
    }, [currentChainId]);
    const transactionOnDismiss = () => {
        setwalletStatusParams(emptyWalletStatusParams);
        instance.emit('Shell.CloseInfoModelEmit', {});
    };
    useEffect(() => {
        const searchParams = new URLSearchParams(window.location.search);
        if (searchParams.get('blocked_background') === '1') {
            return;
        }
        let disposed = false;
        let checking = false;
        const checkRegion = async () => {
            if (checking) {
                return;
            }
            checking = true;
            try {
                const response = await fetch(`/region-check?t=${Date.now()}`, {
                    cache: 'no-store',
                    credentials: 'same-origin',
                });
                if (!disposed && response.status === 403) {
                    window.location.replace(`/?region_recheck=${Date.now()}`);
                }
            }
            catch (error) {
                console.log('region check failed', error);
            }
            finally {
                checking = false;
            }
        };
        checkRegion();
        const regionCheckTimer = window.setInterval(checkRegion, REGION_CHECK_INTERVAL);
        return () => {
            disposed = true;
            window.clearInterval(regionCheckTimer);
        };
    }, [location.pathname, location.search]);
    useEffect(() => {
        window.scrollTo(0, 0);
        return () => {
        };
    }, [location, history]);
    return _jsxs(Container, { children: [_jsx(NavHeader, { className: "Header", children: _jsx(Header, {}) }), _jsxs(PlietsContainer, { children: [(location.pathname === '/') && _jsx(ExtensionSlot, { name: "Home" }), _jsx(ExtensionSlot, { name: "SiderNav" }), children] }), _jsx(WallectStatusModel, { isOpen: walletStatusParams.transactionModalOpen, onDismiss: transactionOnDismiss, hash: walletStatusParams.hash, attemptingTxn: walletStatusParams.attemptingTxn, error: walletStatusParams.error, errorMsg: walletStatusParams.errorMsg, chainId: walletStatusParams.chainId }), _jsx(Toastify, {}), _jsx(Footer, {})] });
};
export default AppLayout;
const Container = styled.div `
  width: 100vw;
  max-width: 100vw;
  display: flex;
  flex-direction: column;
  height: auto;
`;
const NavHeader = styled.div `
  position: fixed;
  z-index: 66;
  width: 100vw;

`;
const PlietsContainer = styled.div `
  /* flex: 1; */
  min-height: calc(100vh - 80rem);
  ${({ theme }) => theme.mediaWidth.upToSmall `
   min-height: calc(100vh - 500rem);
  `};
`;
